import apiV3 from "../utils/apiV3";

async function doGetLanguages() {
    return await apiV3.get(`envimpact/languages`);
}

export {
    doGetLanguages
}
